import type { CalculatorsOverviewLocaleContent } from '../types'

export const calculatorsOverviewEn: CalculatorsOverviewLocaleContent = {
  title: 'Engineering Calculators - Toolvance',
  description: 'Free engineering calculators for electrical, energy, mechanical, thermal, and physics calculations.',
  breadcrumbHome: 'Home',
  breadcrumbCurrent: 'Calculators',
  heading: '🧮 Engineering Calculators',
  intro: 'Accurate engineering calculations across 5 disciplines.',
  countNounSingular: 'calculator',
  countNounPlural: 'calculators',
  popularHeading: 'Popular Calculators',
}
